module.exports = __webpack_public_path__ + "img/ht22.7eb3f5d8.png";